<template>
  <div :class="$style.container">
    <div :class="$style.header">

      <div :class="$style.mainIcon">
        <base-icon :name="headerIcon" />
      </div>

      <div :class="$style.information">
        <div :class="$style.title">
          <slot name="title" />
        </div>

        <div :class="$style.summary">
          <slot name="summary" />
        </div>
      </div>

      <div :class="$style.closeIcon" @click="$emit('close')">
        <base-icon name="basic_plus-1" :size="16" />
      </div>

    </div>

    <div :class="$style.content">
      <slot name="content" />
    </div>

    <div v-if="$slots.hasOwnProperty('footer')" :class="$style.footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionDetailsTemplate',
  props: {
    headerIcon: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +flex-direction(column)
    +size(100%, auto)

  .header
    +flexbox
    +size(100%, auto)
    padding: 30px
    background: linear-gradient(249.76deg, #37B55E -8.32%, #7BD3FF 108.85%)

  .mainIcon
    color: var(--color-white)
    flex: none

  .closeIcon
    color: var(--color-white)
    cursor: pointer
    flex: none

  .information
    +flexbox
    +flex-direction(column)
    +size(100%, auto)
    margin: 0 5px 0 25px

  .title
    +font-type('semi-bold', 13, 20)
    margin-bottom: 7px
    color: var(--color-white)

  .summary
    +font-type('semi-bold', 18, 21)
    color: var(--color-white)

  .content
    padding: 20px 30px

  .footer
    +flexbox
    +justify-content(center)
    +align-items(center)
    box-shadow: inset 0px 1px 0px 0px rgba(39, 40, 60, .1)
</style>
